import React, { memo } from 'react';
import { AlertTriangle } from 'lucide-react';

const Disclaimer = () => {
  return (
    <div className="bg-red-600 text-white py-2 px-4 text-center text-sm">
      <div className="flex items-center justify-center gap-2">
        <AlertTriangle className="w-4 h-4" />
        <p>
          JEUX D'ARGENT ET DE HASARD PEUVENT ÊTRE DANGEREUX: PERTES D'ARGENT, CONFLITS FAMILIAUX, ADDICTION. 
          <a href="https://www.anj.fr" target="_blank" rel="noopener noreferrer" className="underline ml-1 font-semibold">
            RETROUVEZ NOS CONSEILS SUR ANJ
          </a>
        </p>
      </div>
    </div>
  );
};

export default memo(Disclaimer);

